import UNIT_TYPES, {getUnitPrice} from "../../configs/units";
import {FACTIONS} from "../../constants/factions";
import {DWARVES_RESTRICTED_UNIT_TYPES} from "../../configs/factions/dwarves";

export const getUnitTypesForRecruitment = (player) => {
  let unitTypes = Object.values(UNIT_TYPES).map(unitType => {
    const {price, isDiscount} = getUnitPrice(unitType.id, player);

    return {
      ...unitType,
      price,
      isDiscount,
    };
  })

  switch (player.factionId) {
    case FACTIONS.DWARVES:
      unitTypes = unitTypes.filter(unitType => !DWARVES_RESTRICTED_UNIT_TYPES.includes(unitType.id));
      break;
    case FACTIONS.GIANTS:
      unitTypes = unitTypes.filter(unitType => unitType.id === UNIT_TYPES.D20.id);
      break;
    default:
  }

  return unitTypes;
}